import React from 'react'

export default function GalleryScreen() {
  return (
    <div>GalleryScreen</div>
  )
}
